export default "__VITE_ASSET__hEXF2czo__"